import { FC } from 'react';

import { UserPopover } from '@bonusly/common-user-popover';
import { Avatar } from '@bonusly/design-system';

import { useFetchUser } from './hooks/use-fetch-user';

interface UserAvatarProps {
	userId: string;
}

export const UserAvatar: FC<UserAvatarProps> = ({ userId, ...rest }) => {
	const { data } = useFetchUser(userId);

	if (!data) {
		return null;
	}

	return (
		<UserPopover userId={userId}>
			<Avatar name={data.user.name} src={data.user.imageUrl} {...rest} />
		</UserPopover>
	);
};
